import Immutable from 'immutable'
import * as types from '../constants/StructureActionTypes'

const initialState = Immutable.Map({
	sports: null,
	categories: Immutable.Map(),
    tournaments: Immutable.Map(),
    events: Immutable.Map(),
    selected: Immutable.Map()
})

function receiveSports(state, sports){
	return state.set('sports', Immutable.fromJS(sports));	
}

function receiveCategories(state, sportId, categories){
	return state.setIn(['categories', sportId], Immutable.fromJS(categories));	
}

function receiveTournaments(state, cisId, tournaments){
	return state.setIn(['tournaments', cisId], Immutable.fromJS(tournaments));	
}

function receiveEvents(state, tournamentId, events){
	return state.setIn(['events', tournamentId], Immutable.fromJS(events));
}

function select(state, type, value){
	return state.setIn(['selected', type], value);	
}

export default function lotteries (state = initialState, action) {
  switch (action.type) {
  	case types.RECEIVE_SPORTS:
  		return receiveSports(state, action.sports);
  	case types.RECEIVE_CATEGORIES:
  		return receiveCategories(state, action.sport, action.categories);
    case types.RECEIVE_TOURNAMENTS:
        return receiveTournaments(state, action.cis, action.tournaments);
    case types.RECEIVE_EVENTS:
        return receiveEvents(state, action.tournament, action.events);
    case types.SELECT_SPORT:
        return select(state, 'sport', action.id);
    case types.SELECT_CATEGORY:
        return select(state, 'cis', action.id);
    case types.SELECT_TOURNAMENT:
        return select(state, 'tournament', action.id);
    case types.SELECT_EVENT:
        return select(state, 'event', action.id);
    default:
      return state;
  }
}